module.exports = __webpack_public_path__ + "assets/img/12_78_big.9986856c.jpg";